<template>
	<page>
		<module title="开通代理订单详情">
			<c-detail >
				<c-detail-item label="交易单号" >
					{{detailData.record_number}}
				</c-detail-item>
                <c-detail-item label="会员信息" >
                    <template v-slot="{data}">
			            <span>
			              {{detailData.user_manage_mobilephone}}
			              <span v-if="detailData.nick_name && detailData.nick_name!=''">({{detailData.nick_name}})</span>
			            </span>
                    </template>
                </c-detail-item>
                <c-detail-item label="交易金额" >
                    <template v-slot="{data}">
                        <span>￥{{(detailData.money||0).toFixed(2)}}</span>
                    </template>
                </c-detail-item>
                <c-detail-item label="购买等级" >{{detailData.level_name}}</c-detail-item>
                <c-detail-item label="审核状态" >
					<template v-slot="{data}">
                        <span style="color:red" v-if="detailData.check_state==3">审核驳回</span>
                        <span style="color:green" v-if="detailData.check_state==2">审核通过</span>
                        <span style="color:gray" v-if="detailData.check_state==1">待审核</span>
					</template>
				</c-detail-item>
				<c-detail-item label="支付渠道" >
					<template v-slot="{data}">
						<span v-if="detailData.payment_state==1">--</span>
						<span v-else>{{detailData.payment_type}}</span>
					</template>
				</c-detail-item>
				<c-detail-item label="第三方支付单号" >
                    <template v-slot="{data}">
                        <span v-if="detailData.third_number">{{detailData.third_number}}</span>
                        <span v-else>--</span>
                    </template>
				</c-detail-item>
				<c-detail-item label="支付时间">
                    <template v-slot="{data}">
                        <span v-if="detailData.payment_date">{{detailData.payment_date}}</span>
                        <span v-else>--</span>
                    </template>
				</c-detail-item>
                <c-detail-item label="支付凭证" v-if="detailData.pay_voucher_url" full>
                    <template v-slot="{data}">
                        <c-image :src="detailData.pay_voucher_url" size="60" preview></c-image>
                    </template>
                </c-detail-item>
                <c-detail-item label="审核人">
                    <template v-slot="{data}">
                        <span v-if="detailData.check_user_name">{{detailData.check_user_name}}</span>
                        <span v-else>--</span>
                    </template>
                </c-detail-item>
                <c-detail-item label="审核时间">
                    <template v-slot="{data}">
                        <span v-if="detailData.check_date">{{detailData.check_date}}</span>
                        <span v-else>--</span>
                    </template>
                </c-detail-item>
                <c-detail-item label="审核驳回原因" v-if="detailData.check_state==3 && detailData.reject_reason" full>
                    <template v-slot="{data}">
                        <span style="color:red;">{{detailData.reject_reason}}</span>
                    </template>
                </c-detail-item>
				<c-detail-item label="开通明细">
				    <c-table ref="table" v-model="detailList" height="200" :paging="false">
				        <c-table-column
				            label="区域"
				            name="region_name"
				            width="150"
				        ></c-table-column>
						
						<c-table-column
						    label="爆款类目"
						    name="product_type_name"
						    width="200"
						></c-table-column>
						
						<c-table-column
						    label="开通费用"
						    name="money"
						    width="100"
						>
							<template v-slot="row">
							    {{'¥'+parseFloat(row.data.money).toFixed(2)}}
							</template>
						</c-table-column>
					</c-table>
				</c-detail-item>
			</c-detail>

            <template slot="button">
                <c-button v-if="auth('b_membership_record_check') && detailData.check_state == 1" size="m" @click="checkHandle('pass')">审核通过
                </c-button>
                <c-button v-if="auth('b_membership_record_check') && detailData.check_state == 1" size="m" color="red" @click="checkHandle('reject')">审核驳回
                </c-button>
            </template>
            <!--审核驳回原因弹框 -->
            <c-dialog ref="rejectReason" title="不通过原因" width="550" button-name="审核驳回" @resolve="rejectHandle">
                <div class="order-remark">
                    <textarea v-model="rejectReason" placeholder="请输入不通过原因..."></textarea>
                </div>
            </c-dialog>
		</module>
	</page>
</template>

<script>
	import {mapState} from "vuex";
    import {mapGetters} from "vuex";

	export default {
		name: 'm_membership_record_detail',
		props: {
			id: String
		},
		data() {
			return {
				detailData: {},
				detailList: [],
                rejectReason: ''
			}
		},
		mounted() {
			this.detail();
		},

		computed: {
			...mapState(['systemConfig']),
            ...mapGetters({
                auth: 'power'
            })
		},

		watch: {
			id() {
				this.detail();
			}
		},

		methods: {
			detail() {
				this.request({
					url: '/user/upgrade/record/detail',
					data: {id: this.id},
					loading: true,
					success: data => {
						this.detailData = data.agentOrdeInfo;
						this.detailList = data.agentOrderDetailList;
					}
				});
			},
            //审核订单
            checkHandle(type, confirm) {
                if (type == 'pass') {
                    this.$confirm({
                        text: '审核通过即为该用户开通对应的区域代理，是否确定已收到订单单转账金额？',
                        resolve: () => {
                            this.request({
                                url: '/user/upgrade/record/check',
                                data: {
                                    id: this.id,
                                    check_state: 2
                                },
                                loading: true,
                                success: () => {
                                    this.$message({
                                        text: '审核成功'
                                    });
                                    this.detail();
                                    this.$bus.$emit('m_membership_record.update', {});
                                }
                            });
                        }
                    });
                } else if (confirm) {
                    this.request({
                        url: '/user/upgrade/record/check',
                        data: {
                            id: this.id,
                            check_state: 3,
                            reject_reason: this.rejectReason.trim()
                        },
                        loading: true,
                        success: () => {
                            this.$message({
                                text: '订单审核驳回执行成功'
                            });
                            this.detail();
                            this.$bus.$emit('m_membership_record.update', {});
                        }
                    });
                } else {
                    this.rejectHandle();
                }
            },
            //审核（提交数据）
            rejectHandle(stop) {
                if (!stop) {
                    this.rejectReason = '';
                    this.$refs.rejectReason.open();
                } else {
                    stop();

                    if (!this.rejectReason.trim()) {
                        this.$message({
                            text: '请填写审核驳回原因'
                        });
                        return;
                    }

                    this.checkHandle('reject', true);
                    this.$refs.rejectReason.close();
                    this.$bus.$emit('order.update', {});
                }
            },
		}
	}
</script>